/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TextFormat {
  Plaintext = 'Plaintext',
  Markdown = 'Markdown'
}
